module.exports = __webpack_public_path__ + "media/images/flags/32/Equatorial-Guinea-e6b580eda372359f252af87d8cf67ff5.png";